import React from "react";
import { Link } from "react-router-dom";
import axellogo from "../images/new-logo.png";

const PNav = () => {
  return (
    <nav className="p-nav">
      <img className="p-nav-logo" src={axellogo} />
      <div>
        <Link className="p-nav-home" to="/">
          Home
        </Link>
        <Link to="/contact">Contact</Link>
        <Link to="/about">About</Link>
      </div>
    </nav>
  );
};

export default PNav;
